import React, { FC } from 'react';
import classnames from 'classnames';

import Link from 'buyside/components/presentation/Link/link';

import styles from 'buyside/components/presentation/ContestShowPage/ContestPrizes/contestPrizesStyles.scss';

import { ContestShowQuery } from 'interfaces/graphql-typings';

const ContestSponsors: FC<{ sponsors: NonNullable<ContestShowQuery['contest']>['sponsors'] }> = ({
  sponsors
}): React.ReactElement => {
  return (
    <div className={styles.sponsorContainer}>
      {sponsors?.map((sponsor, idx) => {
        if (!sponsor?.sponsorImage) return null;

        return (
          <div key={idx} className={classnames(styles.sponsorImageWrapper, styles.image)}>
            <Link to={sponsor.sponsorTrackingLink}>
              <img alt="sponsorImage" src={sponsor.sponsorImage} />
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default ContestSponsors;
